import LocationPinSmallIconPath from "@ingka/ssr-icon/paths/location-pin-small";

export default LocationPinSmallIconPath;
